import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

const cellRef = React.createRef();
const MIN_ROTATE_WIDTH_VALUE = 20;

export function LabelCell(props) {
  let style = {
    //height: '32px'
    //width: "77px",
    height: "215px",
    whiteSpace: "nowrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    transform: "none !important",
    position: "relative"
  };

  if (cellRef.current) {
    const {clientWidth} = cellRef.current;
    if (clientWidth < MIN_ROTATE_WIDTH_VALUE) {
      style = {
        transform: 'rotate(-90deg)',
        height: '90px',
      };
    }
  }

  return (
    <div ref={cellRef} style={style} className={props.className}>
      <p className={`${props.className}__label`} style={{
        position: "absolute",
        bottom: "-20px",
        left: "28px",
        transformOrigin: "0 0",
        transform: "rotate(-90deg)",
      }}><ReactMarkdown rehypePlugins={[rehypeRaw]} components={{p: 'span'}}>{(props.useAbbrevLabel)?props.abbrevLabel:props.label}</ReactMarkdown></p>
    </div>
  );
}

LabelCell.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * Label to dispaly on the cel
   */
  label: PropTypes.string,
};

LabelCell.defaultProps = {};
